/** 官网公网地址，用于 RSS 文章链接（与 CMS 域名可不同） */
function siteUrl(): string {
  const fromEnv = (import.meta.env.VITE_SITE_URL ?? '').replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined') {
    const base = __BASE_PATH__.replace(/\/$/, '');
    return `${window.location.origin}${base}`;
  }
  return 'https://geelx.com';
}

function normalizeLocale(locale?: string): string {
  const raw = (locale ?? 'zh-CN').toLowerCase();
  if (raw.startsWith('en')) return 'en';
  if (raw.startsWith('zh-tw') || raw.startsWith('zh-hk')) return 'zh-TW';
  return 'zh-CN';
}

/** 访客可用的 RSS 订阅地址 */
export function getRssFeedUrl(locale?: string): string {
  const override = (import.meta.env.VITE_RSS_FEED_URL ?? '').trim();
  if (override) return override;

  const cmsBase = (import.meta.env.VITE_CMS_NEWS_API_BASE ?? '').replace(/\/$/, '');
  if (cmsBase) {
    const q = new URLSearchParams({
      s: 'news',
      c: 'json',
      m: 'rss',
      locale: normalizeLocale(locale),
      site: siteUrl(),
    });
    return `${cmsBase}/index.php?${q.toString()}`;
  }

  const base = __BASE_PATH__.replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${base}/rss.xml`;
  }
  return `${base}/rss.xml`;
}
